import l from "./design-system.es205.js";
import { resolveComponent as r, openBlock as t, createElementBlock as c, createElementVNode as a, createTextVNode as s, createVNode as i, createBlock as m } from "vue";
/* empty css                    */
import d from "./design-system.es128.js";
const u = {
  name: "DsIcon",
  components: {
    SvgIcon: l
  },
  props: {
    /**
     * The name of the icon
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Displays a badge on the top right corner of the icon box
     */
    showBadge: Boolean,
    /**
     * Color of the icon where the value is a color name from the design system, e.g. `text-normal`, `text-subtle`, `blue-800`.  Does not apply a color when a value is not provided.
     */
    color: {
      type: String,
      default: null
    },
    /**
     * The size of the icon.  This can either be a named size like `xs`, `sm`, `md`, `lg` or a number representing the size in pixels.
     */
    size: {
      type: [String, Number],
      default: null,
      options: ["xs", "sm", "md", "lg"]
    }
  }
}, g = {
  key: 0,
  class: "icon-with-badge"
};
function f(_, o, e, p, v, z) {
  const n = r("SvgIcon");
  return e.showBadge ? (t(), c("div", g, [
    o[0] || (o[0] = a("div", { class: "badge" }, null, -1)),
    o[1] || (o[1] = s()),
    i(n, {
      name: e.name,
      color: e.color,
      size: e.size
    }, null, 8, ["name", "color", "size"])
  ])) : (t(), m(n, {
    key: 1,
    name: e.name,
    color: e.color,
    size: e.size
  }, null, 8, ["name", "color", "size"]));
}
const x = /* @__PURE__ */ d(u, [["render", f], ["__scopeId", "data-v-22a86902"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es58.js.map
